import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { Context, Models } from '@grandvisionhq/carts-v2';
import { toast, Loader } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useLink } from '@grandvisionhq/frk-routing';
import { useSync } from '@grandvisionhq/lib-utils-w3c';
import { Hooks, PaymentMethod, PaymentServiceProvider } from '@grandvisionhq/payments';
import { useDispatch, useIntl, useSelector, useFeatureToggles } from '@grandvisionhq/state';
import { init } from '../actions.js';
import { pushExpressCheckoutEventToDataLayer, pushExpressCheckoutSubmitEventToDataLayer } from '../data-layer.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { toggleExpressCheckout, markFieldsTouched } from '../StepShipping/actions.js';
import { getShippingDetails } from '../StepShipping/selectors.js';
import '../context/CheckoutSettings/context.js';
import { getCheckout, isInitialized } from '../selectors.js';
import { useSetCustomerDetails } from '../hooks/operations/use-set-customer-details.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import { CheckoutErrorsMapping } from '../mappers/errors-mapping.js';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import 'history';
import { getShippingMethodInfo } from '../utils/get-shipping-method-info.js';
import '../utils/has-cart-errors.js';
import { useCreateOrder } from '../hooks/orders/use-create-order.js';
import { useCreateOrderDraft } from '../hooks/orders/use-create-order-draft.js';
import { useRedirectToOrderComplete } from '../hooks/orders/use-redirect-to-order-confirm-page.js';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import { mapPaymentDataToCustomerDetails } from '../mappers/data/map-payment-data-to-customer-details.js';
import { mapPaymentDataToSummaries } from '../mappers/view/map-payment-data-to-summaries.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/shipping';
import '../StepShipping/modules/ShippingMethods/state/selectors.js';
import '../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import { useFormSlot } from '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { Header } from '../modules/Header/Header.js';
import '@grandvisionhq/bloomreach';
import { ExpressOverview } from './ExpressOverview.js';
import { useGetExpressLabels } from './hooks/use-get-express-labels.js';
import { useSetDefaultShippingMethod } from './hooks/use-set-default-shipping-method.js';

const ExpressOverviewContainer = (props)=>{
    const { type , backButton , referenceId , paymentToken , shippingMethodsAsides  } = props;
    const { expressCheckout  } = useFormSlot();
    const dispatch = useDispatch();
    const { currency , country , locale  } = useIntl();
    const { loading , cart  } = Context.useCart();
    const { onClick: navigateToCart  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const broadCastChannel = useSync('new-cart-created').getChannel();
    const shippingDetails = useSelector(getShippingDetails);
    broadCastChannel.onmessage = ()=>{
        toast.failed('cart.errors.cartNotInActiveState');
        navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
    };
    const checkoutState = useSelector(getCheckout);
    const redirectToOrderComplete = useRedirectToOrderComplete();
    const { setCustomerDetails , isUpdating: isCustomerDetailsUpdating  } = useSetCustomerDetails();
    const createOrderDraft = useCreateOrderDraft();
    const [createOrder, { loading: isOrderUpdating  }] = useCreateOrder();
    const { setDefaultShippingMethod , areShippingMethodsLoading  } = useSetDefaultShippingMethod();
    const { featureConfigs , isMyAccountEnabled  } = useFeatureToggles();
    const { expressDefaultShippingMethod  } = featureConfigs;
    const authState = useAccount();
    const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn;
    const { labels , summaryLabels  } = useGetExpressLabels(type);
    const { getPaymentDataByToken , data , isPaymentDataLoading  } = Hooks.useGetPaymentDataByToken({
        onError: ()=>{
            toast.failed(CheckoutErrorsMapping.SomethingWentWrong);
            navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
        }
    });
    const { addresses , contactDetails  } = mapPaymentDataToSummaries(data);
    const dobFormRef = React.useRef(null);
    React.useEffect(()=>{
        if (!isInitialized({
            checkout: checkoutState
        })) {
            // Initialize checkout state
            dispatch(init());
        }
    }, [
        dispatch,
        checkoutState
    ]);
    React.useEffect(()=>{
        dispatch(toggleExpressCheckout({
            enabled: true
        }));
        return ()=>{
            dispatch(toggleExpressCheckout({
                enabled: false
            }));
        };
    }, [
        dispatch
    ]);
    React.useEffect(()=>{
        if (paymentToken) {
            getPaymentDataByToken(paymentToken);
        }
    // should only run once or when the payment token is found
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentToken
    ]);
    React.useEffect(()=>{
        if (expressDefaultShippingMethod && !areShippingMethodsLoading && expressDefaultShippingMethod.length) {
            setDefaultShippingMethod(expressDefaultShippingMethod);
        }
    // should only run once or when the shipping method is found
    // setDefaultShippingMethod in dependencies will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expressDefaultShippingMethod,
        areShippingMethodsLoading
    ]);
    React.useEffect(()=>{
        if ((cart === null || cart === void 0 ? void 0 : cart.checkoutState) == Models.CheckoutState.Finalized) {
            navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.checkoutState
    ]);
    React.useEffect(()=>{
        if (cart) {
            pushExpressCheckoutEventToDataLayer(cart, currency);
        }
    // should only run once or when the cart or cart line items change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.lineItems.length,
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    const handleExpressCheckoutSubmitEvent = React.useCallback(()=>{
        cart && pushExpressCheckoutSubmitEventToDataLayer({
            cart,
            paymentMethod: type,
            isLoggedIn
        });
    }, [
        cart,
        isLoggedIn,
        type
    ]);
    const onNextClick = function() {
        var _ref = swcHelpers.asyncToGenerator(function*() {
            var ref;
            dispatch(markFieldsTouched());
            const dateOfBirth = (ref = shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout.formData['express-checkout-dob']) === null || ref === void 0 ? void 0 : ref.value;
            if (// isValid will only check for required, not for valid date
            !(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout.isValid) || dateOfBirth && !Util.validations.isDateOfBirth(dateOfBirth)) {
                // Focus to the first occurrence of invalid date input field
                focusToDOBField();
                return;
            }
            try {
                handleExpressCheckoutSubmitEvent();
                const paymentData = mapPaymentDataToCustomerDetails(data, locale, country);
                const updatedPaymentData = dateOfBirth && paymentData.customerDetails ? swcHelpers.objectSpread({}, paymentData, {
                    customerDetails: swcHelpers.objectSpread({}, paymentData.customerDetails, {
                        dateOfBirth
                    })
                }) : paymentData;
                yield setCustomerDetails(updatedPaymentData);
                const createOrderDraftPayload = yield createOrderDraft({
                    paymentDetails: {
                        data: {
                            referenceId
                        },
                        isValid: true,
                        type: PaymentMethod.PAYPAL
                    },
                    selectedPaymentMethod: {
                        type: PaymentMethod.PAYPAL,
                        provider: PaymentServiceProvider.PAYPAL
                    },
                    returnUrl: window.location.href
                });
                const orderResponse = yield createOrder(createOrderDraftPayload);
                redirectToOrderComplete({
                    cartId: (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.cartId) || createOrderDraftPayload.checkoutId,
                    orderData: orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.orderDataToken,
                    expressOrder: true
                });
            } catch (e) {
                console.error(e);
                toast.failed(CheckoutErrorsMapping.CreateOrderFailed);
            }
        });
        return function onNextClick() {
            return _ref.apply(this, arguments);
        };
    }();
    const focusToDOBField = ()=>{
        if (dobFormRef.current) {
            dobFormRef.current.scrollIntoView({
                behavior: 'smooth'
            });
            const inputElement = dobFormRef.current.getElementsByClassName('_is_invalid')[0];
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
        }
    };
    const shippingMethodInfo = getShippingMethodInfo(summaryLabels.summary, expressDefaultShippingMethod, shippingMethodsAsides);
    const shippingMethodInfoComponent = ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, shippingMethodInfo.label, " ", shippingMethodInfo.aside && shippingMethodInfo.aside)
    ;
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-overview-container"
    }, /*#__PURE__*/ React.createElement(Header, {
        title: labels.paymentMethod,
        backButton: backButton
    }), /*#__PURE__*/ React.createElement("section", {
        className: "express-overview-container__inner"
    }, /*#__PURE__*/ React.createElement("main", {
        className: "express-overview-container__main"
    }, loading && isPaymentDataLoading && /*#__PURE__*/ React.createElement("section", {
        className: "express-overview-container__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)), !loading && !isPaymentDataLoading && cart && /*#__PURE__*/ React.createElement(ExpressOverview, {
        isUpdating: isCustomerDetailsUpdating || isOrderUpdating,
        onNextClick: onNextClick,
        labels: labels,
        shippingMethodInfo: shippingMethodInfoComponent(),
        addresses: addresses,
        contactDetails: contactDetails,
        dobForm: expressCheckout,
        dobFormRef: dobFormRef
    }))));
};

export { ExpressOverviewContainer };
//# sourceMappingURL=ExpressOverviewContainer.js.map
